import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatDateTime } from 'utils'

export default function DateFormatter({ info }) {
  const { value } = getInfo(info)
  if (!value) return '--'
  return formatDateTime(value)
}
